import { useEffect, useState } from "react";
import Loader from "react-loaders";
import { MapContainer, TileLayer, Marker, Popup } from "react-leaflet";
import { useRef } from "react";
import emailjs from "@emailjs/browser";
import AnimatedLetters from "../AnimatedLetters";
import "./index.scss";

const Contact = () => {
  const [letterClass, setLetterClass] = useState("text-animate");
  const [sendMailLoading, setSendMailLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const form = useRef();

  useEffect(() => {
    return setTimeout(() => {
      setLetterClass("text-animate-hover");
    }, 3000);
  }, []);
  useEffect(() => {
    const checkScreenWidth = () => {
      setIsMobile(window.innerWidth < 768);
    };

    checkScreenWidth();

    window.addEventListener("resize", checkScreenWidth);

    // Clean up event listener on component unmount
    return () => window.removeEventListener("resize", checkScreenWidth);
  }, []);
  const sendEmail = (e) => {
    e.preventDefault();
    setSendMailLoading(true);
    console.log(form, ",formmmm");
    emailjs
      .sendForm(
        "service_8bwl8e2",
        "template_hixdz37",
        form.current,
        "Gze4CoOnFs7iZOKV-"
      )

      .then(
        () => {
          alert("Message successfully sent!");
          window.location.reload(false);
        },
        (er) => {
          console.log("errrrr--->", er);
          alert("Failed to send the message, please try again");
        }
      )
      .finally(() => {
        setSendMailLoading(false);
      });
  };

  return (
    <>
      <div className="container contact-page">
        <div className="text-zone">
          {sendMailLoading && (
            <Loader type="ball-pulse" active color="#00a8ff" />
          )}
          <h1>
            <AnimatedLetters
              letterClass={letterClass}
              strArray={["C", "o", "n", "t", "a", "c", "t", " ", "m", "e"]}
              idx={15}
            />
          </h1>
          <p>
            I am interested in freelance opportunities - especially on ambitious
            or large projects. However, if you have any other requests or
            questions, don't hesitate to contact me using below form either.
          </p>
          <div className="contact-form">
            <form ref={form} onSubmit={sendEmail}>
              <ul>
                <li className="half">
                  <input
                    placeholder="Name"
                    type="text"
                    name="from_name"
                    required
                  />
                </li>
                <li className="half">
                  <input
                    placeholder="Email"
                    type="email"
                    name="from_name"
                    required
                  />
                </li>
                <li>
                  <input
                    placeholder="Subject"
                    type="text"
                    name="subject"
                    required
                  />
                </li>
                <li>
                  <textarea
                    placeholder="Message"
                    name="message"
                    required
                  ></textarea>
                </li>
                <li>
                  <input
                    type="submit"
                    className="flat-button"
                    value="SEND"
                    disabled={sendMailLoading ? true : false}
                    style={{
                      cursor: sendMailLoading ? "not-allowed" : "pointer",
                    }}
                  />
                </li>
              </ul>
            </form>
          </div>
        </div>
        <div className="info-map">
          Oshri Tzagay
          <br />
          Israel,
          <br />
          Hadror 2/9 <br />
          Yavne
          <br />
          <br />
          <span>itsoshriel@gmail.com</span>
        </div>
        {!isMobile && (
          <div className="map-wrap">
            <MapContainer center={[31.87094, 34.74216]} zoom={13}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              <Marker position={[31.87094, 34.74216]}>
                <Popup>I'm living here, come over for a cup of coffee :)</Popup>
              </Marker>
            </MapContainer>
          </div>
        )}
      </div>
      <Loader type="pacman" />
    </>
  );
};

export default Contact;
